import React from 'react';

function Header() {
    return (
        <div className="text-center mb-4">
            <img src="/maccLogo.png" alt="Macc Logo" width={189} height={70.8} />
            <h2 className="text-[#E6BB6C] text-center mt-3">Solicitud de Documentos</h2>
        </div>
    );
}

export default Header;